export default window.Promise;
